export const WIZARD_STATE_KEY_NAME = 'wizard_state';
